import { render, staticRenderFns } from "./component-small-loader.html?vue&type=template&id=5a985d5d&scoped=true&external"
import script from "./component-small-loader.js?vue&type=script&lang=js&external"
export * from "./component-small-loader.js?vue&type=script&lang=js&external"
import style0 from "./component-small-loader.scss?vue&type=style&index=0&id=5a985d5d&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a985d5d",
  null
  
)

export default component.exports